/* Tiloa — micro-interactions de la page d'accueil.
   1. Apparition douce du contenu des sections au défilement (IntersectionObserver, sans écouteur de scroll).
   2. Ouverture et fermeture fluides des accordéons de la FAQ (<details>), accessibles au clavier.
   Sans JavaScript ou avec prefers-reduced-motion, tout reste visible et fonctionne normalement. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- 1. Révélation des sections ---------- */
  (function reveal() {
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) return;

    var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section:not(.section-sticky-atc)'));
    // On anime le contenu (et non le fond) des sections situées sous la ligne de flottaison.
    var targets = sections.slice(1).map(function (section) {
      // Premier élément visible de la section (on ignore les balises <style> et <script>).
      return Array.prototype.find.call(section.children, function (child) {
        return child.tagName !== 'STYLE' && child.tagName !== 'SCRIPT' && child.tagName !== 'LINK' && child.offsetHeight > 0;
      });
    }).filter(function (el) {
      // Un élément fixe (barre d'achat collante) n'est pas un contenu à faire apparaître.
      return el && el.offsetHeight > 0 && getComputedStyle(el).position !== 'fixed' && el.getBoundingClientRect().top > window.innerHeight;
    });
    if (!targets.length) return;

    document.documentElement.classList.add('tiloa-reveal-ready');
    targets.forEach(function (el) { el.classList.add('tiloa-reveal'); });

    // Apparition échelonnée des cartes d'une même section (+60 ms, plafonnée à 360 ms).
    var CHILDREN = '[data-reveal-item], .review-card, .reassurance__item, .video-empty__card, .packaging__stat, .rb-faq-container-item';
    targets.forEach(function (el) {
      Array.prototype.forEach.call(el.querySelectorAll(CHILDREN), function (child, i) {
        child.classList.add('tiloa-reveal-child');
        child.style.setProperty('--reveal-delay', Math.min(i * 80, 400) + 'ms');
      });
    });

    var showAll = function () {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

    targets.forEach(function (el) { observer.observe(el); });

    // Sécurités : impression et navigation par ancre affichent immédiatement le contenu.
    window.addEventListener('beforeprint', showAll);
    window.addEventListener('hashchange', showAll);
    if (window.location.hash) showAll();
  })();

  /* ---------- 2. Inclinaison très légère au survol (souris uniquement) ---------- */
  (function tilt() {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var MAX = 2; // degrés
    document.querySelectorAll('[data-tilt], [class^="featured-product-image-wrapper-"], .video-empty__card').forEach(function (el) {
      var frame = null;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          el.style.transform = 'perspective(900px) rotateX(' + (-y * MAX).toFixed(2) + 'deg) rotateY(' + (x * MAX).toFixed(2) + 'deg) translate3d(0,-2px,0)';
        });
      });
      el.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        el.style.transform = '';
      });
    });
  })();

  /* ---------- 3. Hero : la photo suit très légèrement le pointeur (6 px max, souris uniquement) ---------- */
  (function heroDepth() {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)').matches) return;
    var hero = document.querySelector('.hero--stacked');
    var img = hero && hero.querySelector('[class^="hero-bg-image-"] img[class*="hero-bg-desktop-"], [class^="hero-bg-image-"] img');
    if (!img) return;
    var MAXPX = 6, frame = null;
    img.style.transition = 'transform .6s cubic-bezier(.22, 1, .36, 1)';
    img.style.willChange = 'transform';
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        img.style.transform = 'scale(1.02) translate3d(' + (-x * MAXPX).toFixed(1) + 'px,' + (-y * MAXPX).toFixed(1) + 'px,0)';
      });
    });
    hero.addEventListener('pointerleave', function () { img.style.transform = ''; });
  })();

  /* ---------- 4. Accordéons FAQ fluides ---------- */
  (function faq() {
    if (reduceMotion || !('animate' in document.documentElement)) return;

    var items = document.querySelectorAll('.rb-faq-container-item');
    Array.prototype.forEach.call(items, function (details) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.rb-faq-answer');
      if (!summary || !content) return;
      var animation = null;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (animation) animation.cancel();
        details.classList.add('is-animating');

        var startHeight = details.offsetHeight;
        var opening = !details.open;
        if (opening) details.open = true;
        var endHeight = opening ? details.offsetHeight : summary.offsetHeight;

        animation = details.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: opening ? 320 : 260, easing: 'cubic-bezier(.22, 1, .36, 1)' }
        );
        if (opening) {
          content.animate(
            { opacity: [0, 1], transform: ['translateY(-4px)', 'translateY(0)'] },
            { duration: 280, easing: 'ease-out' }
          );
        }
        var current = animation;
        var done = false;
        var finish = function () {
          if (done || animation !== current) return;
          done = true;
          if (current.playState !== "finished") current.cancel();
          content.getAnimations().forEach(function (anim) { anim.cancel(); });
          if (!opening) details.open = false;
          details.classList.remove('is-animating');
          animation = null;
        };
        current.onfinish = finish;
        current.oncancel = function () { details.classList.remove('is-animating'); };
        // Filet de sécurité si l'événement de fin n'est pas émis (onglet en arrière-plan).
        setTimeout(finish, (opening ? 320 : 260) + 80);
      });
    });
  })();
})();
